export const LUCKYDRAW = "luckyDraw"

export const drawType = {
    oneByOne: "One by One",
    allAtOnce: "All at Once"
}